import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Box, styled, Typography } from '@mui/material';
import { EColors, getColor } from 'theme';

const Button = styled(Box)({
    border: '1px solid ' + getColor(EColors.lightGrey),
    borderRadius: '8px',
    height: '40px',
    width: '78px',
    backgroundColor: getColor(EColors.pureWhite),
    display: 'flex',
    gap: '10px',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',

    '&:hover': {
        backgroundColor: getColor(EColors.v3LightGrayBackground),
    },
});

export function BackButton({ onClick }: { onClick: () => void }) {
    return (
        <Button onClick={onClick}>
            <KeyboardBackspaceIcon sx={{ fontSize: 16 }} />
            <Typography variant="body2" fontWeight={500} lineHeight="12px">
                Back
            </Typography>
        </Button>
    );
}
